import React from 'react';
import { Badge } from 'reactstrap';
import { copy, isBuyerLocale } from '../../utils/negotiationCopy';

const PriceDealBanner = ({ price, mode = 'buyer' }) => {
  const locale = isBuyerLocale(mode) ? 'id' : 'en';

  return (
    <div className='neg-deal-banner mt-3' role='status'>
      <div className='neg-deal-banner__icon' aria-hidden='true'>
        <i className='ri-checkbox-circle-fill' />
      </div>
      <div className='neg-deal-banner__body'>
        <div className='neg-deal-banner__title'>{copy.dealTitle[locale]}</div>
        <p className='neg-deal-banner__sub mb-2'>{copy.dealSub[locale]}</p>
        <Badge
          color='success'
          className='px-2 py-1 fs-12 fw-medium rounded-pill'
        >
          {price}
        </Badge>
      </div>
    </div>
  );
};

export default PriceDealBanner;
